module.exports = __webpack_public_path__ + "static/media/Icon 5.06c43b45.png";